import { Button } from '@/shared/ui';
import { useAuthModal } from '@/features/auth';

/** Shown in place of the composer for signed-out readers. */
export function CommentGate() {
  const openAuth = useAuthModal((state) => state.open);
  return (
    <div className="rounded-2xl border border-dashed border-border p-6 text-center">
      <p className="text-sm text-muted-foreground">Sign in to join the conversation.</p>
      <Button className="mt-3" onClick={() => openAuth('login')}>
        Sign in to comment
      </Button>
    </div>
  );
}
